// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3KgzG","imageUploader":"EGiftCard_imageUploader__1NOFO"};